import React,{useState,useEffect} from 'react';
import logo from '../images/haqdarshak-logo.png';
import { useNavigate } from 'react-router-dom';
import projectLogo from '../images/logo-transparent.png'

const SummaryHeader = () => {
  const navigate = useNavigate();
  const [executionDate, setExecutionDate] = useState(null);
      const [isLoading, setIsLoading] = useState(true);
      const [error, setError] = useState(null);
  
      useEffect(() => {
          const fetchData = async () => {
              try {
                  setIsLoading(true);
                  const response = await fetch('https://api-project360-insights.haqdarshak.com/api/last-execution-date/');
                  
                  if (!response.ok) {
                      throw new Error(`HTTP error! Status: ${response.status}`);
                  }
                  
                  const data = await response.json();
                  setExecutionDate(data.last_execution_date);
              } catch (err) {
                  setError(err.message);
                  console.error('Failed to fetch execution date:', err);
              } finally {
                  setIsLoading(false);
              }
          };
  
          fetchData();
      }, []);
  
      const formatDate = (dateString) => {
          if (!dateString) return null;
          
          try {
              const date = new Date(dateString.replace(' AM', ''));
              return date.toLocaleString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true
              });
          } catch (e) {
              return dateString;
          }
      };
  const handleLogout = () => {
    navigate("/"); // Redirect to the login page
  };
  return (
    <div className="fixed flex flex-row h-14 top-0 left-0 w-full bg-white text-black font-extrabold shadow-sm shadow-black z-50 items-center px-4">
      <div className="flex items-center ">
        {/* Logo and Project Name */}
        <div className="flex">
          <img src={logo} alt="Logo" className="h-10 w-auto" />
          <h1 className=" ml-[5vw] text-2xl font-bold tracking-wide text-black flex items-center space-x-1">
            PROJECT360 Dashboard
</h1>
        </div>

        {/* Current Page Title */}
        <div className="text-xl text-black font-bold ml-[15vw]">
          Project Summary
        </div>
         <button
          onClick={handleLogout}
          className="ml-[10vw] bg-red-600 text-white px-4 py-1 rounded-lg hover:bg-red-700 transition"
        >
          Logout
        </button>
      </div>

      {/* Last Update Date Display */}
                <div className="flex items-center text-xs text-gray-500 ml-[3vw]">
                    {isLoading ? (
                        <div className="flex items-center">
                            <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-gray-400 mr-1"></div>
                            <span>Loading update...</span>
                        </div>
                    ) : error ? (
                        <div className="flex items-center text-red-500">
                            <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span>Update failed</span>
                        </div>
                    ) : (
                        <div className="flex items-center">
                            <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span> Data Last Updated At: {formatDate(executionDate)}</span>
                        </div>
                    )}
                </div>
      
    </div>
  );
};

export default SummaryHeader;
